module.exports = __webpack_public_path__ + "img/drilldown_help.52320151.webp";